export const INITIAL_STATE = {
  data: null,
  isLoading: false,
  error: null,
  dafData: null,
  dafError: null,
  stripePaymentIntent: null,
  completedTransactions: [],
};
